import { render } from "./MainIva.vue?vue&type=template&id=61cdd542&scoped=true"
import script from "./MainIva.vue?vue&type=script&lang=js"
export * from "./MainIva.vue?vue&type=script&lang=js"

import "./MainIva.vue?vue&type=style&index=0&id=61cdd542&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61cdd542"]])

export default __exports__